<template>
    <div>
        <PageMenu></PageMenu>
        <div id="app-main" class="zaplac">
            <div class="col-12">
                <div class="section-header no-icon">
                    <h1>Zamówienie usługi transportowej</h1>
                </div>
            </div>
            <div
                style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 400px;
                    flex-direction: column;
                "
                v-show="!token"
            >
                <p style="font-size: 5rem">404</p>
                <p style="font-size: 19px; padding-top: 12px">
                    Nieprawidłowy adres strony
                </p>
            </div>
            <div
                style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 400px;
                    flex-direction: column;
                "
                v-show="error"
            >
                <p style="font-size: 2rem">UWAGA!</p>
                <p style="font-size: 1" v-show="errorReason === 'already_paid'">
                    Płatność zakończona pomyślnie
                </p>
                <p
                    style="font-size: 1.5rem"
                    v-show="errorReason === 'no_valid_token'"
                >
                    Adres strony jest nieprawidłowy
                </p>
            </div>

            <div>
                <div class="order-summary-table" v-if="errorReason === ''">
                    <div class="desktop-order-summary">
                        <div class="dos-name-section" style="min-height: 100px">
                            <h3>Nadawca</h3>
                            <p>
                                {{ orderData.customer.FirstName }}
                                {{ orderData.customer.LastName }}
                            </p>
                            <p></p>
                            <p></p>
                            <p></p>
                        </div>
                        <div class="dos-name-section" style="min-height: 100px">
                            <h3>Odbiorca</h3>
                            <p>DTS Transport Sp. z o.o.</p>
                            <p>ul. Wał Miedzeszyński 251,</p>
                            <p>04-866 Warszawa</p>
                            <p></p>
                        </div>
                        <div class="dos-address-section">
                            <h3>Forma płatności</h3>
                            <p>Przelew online</p>
                        </div>
                        <div class="dos-address-section">
                            <h3>Kwota do zapłaty</h3>
                            <p>
                                {{ orderData.delivery.cost | toFixed }}
                                {{ orderData.delivery.currencyCode }}
                            </p>
                        </div>
                    </div>
                </div>

                <span
                    style="
                        display: inline-block;
                        font-weight: bold;
                        color: #fff;
                        padding: 20px;
                        cursor: pointer;
                        padding: 1rem 1.5rem;
                        background-color: #00d6ff;
                    "
                    @click="startPayment()"
                    >Zapłać</span
                >
            </div>
        </div>
        <PageFooter></PageFooter>
    </div>
</template>

<script>
import PageMenu from "./PageMenu";
import PageFooter from "./PageFooter";

export default {
    components: { PageMenu, PageFooter },
    name: "PayForm",
    props: ["token"],

    data() {
        return {
            isLoading: false,
            error: false,
            errorReason: "",
            orderData: {
                delivery: {
                    cost: "",
                    currencyCode: "",
                },
                customer: {
                    FirstName: "",
                    LastName: "",
                },
            },

            order: null,
        };
    },

    methods: {
        startPayment: function () {
            var url = this.$store.state.urls.startPayment;
            var self = this;
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;
            self.$http
                .post(url, { order: self.order })
                .then(function (response) {
                    self.isLoading = false;

                    if (response.data.status === "ok") {
                        window.location.href = response.data.redirectUrl;
                    }
                });
        },

        assignValues: function (ordData) {
            console.log(ordData);
            this.orderData.delivery.cost = ordData.totalAmount;
            this.orderData.delivery.currencyCode = ordData.currencyCode;
            this.orderData.customer.FirstName = ordData.buyer.firstName;
            this.orderData.customer.LastName = ordData.buyer.lastName;
        },

        getOrderData: function () {
            if (!this.token) {
                return;
            }

            var self = this;

            console.log("getOrderData");
            var url = this.$store.state.urls.getOrderDataForPayu;
            self.$http
                .get(url + "?token=" + self.token)
                .then(function (response) {
                    if (response.data.status === "error") {
                        self.error = true;
                        self.errorReason = response.data.reason;
                    } else if (response.data.status === "ok") {
                        self.order = response.data.orderData;
                        self.order.token = self.token;
                        self.assignValues(response.data.orderData);
                    }
                });
        },
    },

    filters: {
        toFixed: function (val) {
            if (_.trim(val) == "") {
                return "";
            }
            var vNum = parseFloat(val);
            if (_.isNaN(vNum)) {
                return "-";
            }
            return vNum.toFixed(2);
            return "";
        },
    },

    mounted: function () {
        console.log("reday - form payy u");

        this.getOrderData();
    },
};
</script>



// WEBPACK FOOTER //
// PayForm.vue?76e2df4c